import {
  ModalDialog,
  ModalDialogHeader,
  ModalDialogTitle,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogActions,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface StartNewServiceConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onGoToExistingJob: () => void
  onContinueAnyway: () => void
  testId?: string
  goToExistingJobTestId?: string
  continueAnywayTestId?: string
}

/**
 * Dialog for confirming whether the user wants to start a new service when they
 * already have a job in progress.
 */
export function StartNewServiceConfirmationDialog({
  isOpen,
  onClose,
  onGoToExistingJob,
  onContinueAnyway,
  testId,
  goToExistingJobTestId,
  continueAnywayTestId,
}: StartNewServiceConfirmationDialogProps) {
  return (
    <ModalDialog isOpen={isOpen} onClose={onClose} testId={testId}>
      <ModalDialogHeader>
        <ModalDialogTitle>
          You already have a service in progress
        </ModalDialogTitle>
        <ModalDialogDescription>
          Starting a new service may create a duplicate. If this was a mistake,
          return to your existing service instead.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            label="Go to existing job"
            variant="default"
            onPress={onGoToExistingJob}
            testId={goToExistingJobTestId}
          />
          <Button
            variant="outline"
            label="Continue anyway"
            onPress={onContinueAnyway}
            testId={continueAnywayTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
